import { Version } from '@fuse/version/version';

export const FUSE_VERSION = new Version('1.56.4').full;
